import { Card as MuiCard, styled } from '@mui/material';

export const Card = styled(MuiCard)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 10,
  background: theme.palette.grey[500],
  border: `1px solid ${theme.palette.grey[600]}`,
  padding: '10px 15px',
}));
